angular.module('vastdesk').
  component('htmlVideoPlayer',  {
    bindings: {
      playerId: '@',
      src: '@',
      poster: '@',
      clickThruUrl: '@'
    },
    template:
        '<div class="html-video-player-stage">' +
          '<video id="{{$htmlVideoPlayerCtrl.playerId}}" ' +
                 'class="html-video-player-video" ' +
                 'ng-src="{{$htmlVideoPlayerCtrl.src}}" ' +
                 'ng-attr-poster="{{$htmlVideoPlayerCtrl.poster}}" ' +
                 'playsinline></video>' +
          // Full-surface click-through overlay. Custom controls live below the video,
          // so the entire frame is free to open the landing page in a new tab.
          '<a ng-if="$htmlVideoPlayerCtrl.clickThruUrl" ' +
             'class="html-video-player-clickthru" ' +
             'ng-href="{{$htmlVideoPlayerCtrl.clickThruUrl}}" ' +
             'target="_blank" rel="noopener noreferrer" ' +
             'title="{{$htmlVideoPlayerCtrl.clickThruUrl}}" ' +
             'aria-label="Open click-thru URL in a new tab"></a>' +
          // Center play button shown only before playback has ever started. Once
          // clicked it is removed for good; play/pause then lives in the banner below.
          '<button type="button" class="html-video-player-play-button" ' +
                  'ng-show="!$htmlVideoPlayerCtrl.started" ' +
                  'ng-click="$htmlVideoPlayerCtrl.togglePlay()" aria-label="Play"></button>' +
        '</div>' +
        // Shared control row rendered below the video (play/pause, mute, time, progress).
        '<player-controls ' +
          'playing="$htmlVideoPlayerCtrl.playing" ' +
          'muted="$htmlVideoPlayerCtrl.muted" ' +
          'current-time="$htmlVideoPlayerCtrl.currentTime" ' +
          'duration="$htmlVideoPlayerCtrl.duration" ' +
          'on-play-pause="$htmlVideoPlayerCtrl.togglePlay()" ' +
          'on-mute="$htmlVideoPlayerCtrl.toggleMute()"></player-controls>',
    controllerAs: '$htmlVideoPlayerCtrl',
    controller: ['$rootScope', '$scope', '$element', function($rootScope, $scope, $element) {

      var self = this;
      var video;

      self.started = false;
      self.playing = false;
      self.muted = false;
      self.currentTime = 0;
      self.duration = 0;

      var onPlay = function() {
        $scope.$applyAsync(function() { self.playing = true; });
      };

      var onPause = function() {
        $scope.$applyAsync(function() { self.playing = false; });
      };

      var onVolumeChange = function() {
        $scope.$applyAsync(function() { self.muted = video.muted; });
      };

      var onTimeUpdate = function() {
        $scope.$applyAsync(function() {
          self.currentTime = video.currentTime || 0;
          self.duration = isFinite(video.duration) ? video.duration : 0;
        });
      };

      // Drives both the center play button (first play) and the banner play/pause.
      // The first call flips `started`, which permanently removes the center button.
      self.togglePlay = function() {
        self.started = true;
        if (!video) return;
        if (video.paused) {
          video.play().catch(function() {});
        } else {
          video.pause();
        }
      };

      self.toggleMute = function() {
        if (!video) return;
        video.muted = !video.muted;
      };

      this.$postLink = function() {
        video = $element[0].querySelector('.html-video-player-video');
        if (!video) return;
        self.muted = video.muted;
        video.addEventListener('play', onPlay);
        video.addEventListener('pause', onPause);
        video.addEventListener('volumechange', onVolumeChange);
        video.addEventListener('timeupdate', onTimeUpdate);
        video.addEventListener('loadedmetadata', onTimeUpdate);
      };

      $rootScope.$on('videoChange', function(e, args) {
        if (args.playerId === self.playerId) {
          self.src = args.src;
          self.poster = args.poster;
          if (Object.prototype.hasOwnProperty.call(args, 'clickThruUrl')) {
            self.clickThruUrl = args.clickThruUrl;
          }
          if (video) {
            self.started = false;
            self.currentTime = 0;
            self.duration = 0;
            self.playing = false;
            video.load();
          }
        }
      });

      this.$onDestroy = function() {
        if (!video) return;
        video.removeEventListener('play', onPlay);
        video.removeEventListener('pause', onPause);
        video.removeEventListener('volumechange', onVolumeChange);
        video.removeEventListener('timeupdate', onTimeUpdate);
        video.removeEventListener('loadedmetadata', onTimeUpdate);
      };

    }]
});
